

export const ADD_DATA_FAILURE = "ADD_DATA_FAILURE"
export const ADD_DATA_SUCCESS = "ADD_DATA_SUCCESS"
export const ADD_DATA_REQUEST = "ADD_DATA_REQUEST"

export const GET_CART_DATA_FAILURE = "GET_CART_DATA_FAILURE"
export const GET_CART_DATA_SUCCESS = "GET_CART_DATA_SUCCESS"
export const GET_CART_DATA_REQUEST = "GET_CART_DATA_REQUEST"


export const UPDATE_CART_REQUEST = "UPDATE_CART_REQUEST"
export const UPDATE_CART_SUCCESS = "UPDATE_CART_SUCCESS"
export const UPDATE_CART_FAILURE = "UPDATE_CART_FAILURE"


export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST"
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS"
export const DELETE_CART_FAILURE = "DELETE_CART_FAILURE"